var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHooplaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5218 26.7947L22.0718 23.8611C19.9635 22.7273 18.2301 21.0226 17.0773 18.9493L14.0943 13.5895L11.1113 18.9493C9.95845 21.0226 8.22507 22.7273 6.11678 23.8611L0.666748 26.7947L6.11678 29.7243C8.22507 30.8581 9.95845 32.5628 11.1113 34.6362L14.0943 39.9999L17.0773 34.6362C18.2301 32.5628 19.9635 30.8581 22.0718 29.7243L27.5218 26.7947Z",
    fill: "url(#paint0_linear_5928_364)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3335 10.8193L33.7056 8.86094C32.2986 8.1038 31.1417 6.96607 30.3719 5.58243L28.3805 2.01453L26.3891 5.58243C25.6193 6.96607 24.4624 8.1038 23.0555 8.86094L19.4275 10.8193L23.0555 12.7777C24.4564 13.5373 25.6075 14.6748 26.373 16.0562L28.3644 19.6241L30.3557 16.0562C31.1256 14.6726 32.2825 13.5348 33.6895 12.7777L37.3335 10.8193Z",
    fill: "url(#paint1_linear_5928_364)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9168 6.44601L11.2563 5.01489C10.2338 4.45889 9.39451 3.62663 8.83766 2.61646L7.38244 0L5.90705 2.6125C5.34477 3.6254 4.49821 4.45795 3.46825 5.01092L0.803711 6.44205L3.46825 7.87714C4.49543 8.42477 5.3417 9.25016 5.90705 10.2557L7.36229 12.8722L8.81751 10.2557C9.37743 9.25289 10.2164 8.42778 11.2362 7.87714L13.9168 6.44601Z",
    fill: "url(#paint2_linear_5928_364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5928_364",
    x1: 16.6699,
    y1: 2.64643,
    x2: -13.3794,
    y2: 20.8757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B83AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5928_364",
    x1: 30.0979,
    y1: -5.28194,
    x2: 10.062,
    y2: 6.87275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B83AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5928_364",
    x1: 8.61793,
    y1: -5.33355,
    x2: -6.0403,
    y2: 3.57526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B83AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHooplaicon);
export default __webpack_public_path__ + "static/media/hooplaicon.d8d3cbb7.svg";
export { ForwardRef as ReactComponent };